import { FC, ReactNode } from "react";
import { Alert, Stack } from "@mui/material";
import { AutomationProviderSelection } from "./AutomationProviderSelection";
import { AutomationAccountsSelection } from "./AutomationAccountsSelection";
import { AutomationRegionsSelection } from "./AutomationRegionsSelection";

interface AutomationEnvironmentContentProps {
  alertMessage?: ReactNode;
}

export const AutomationEnvironmentContent: FC<
  AutomationEnvironmentContentProps
> = ({ alertMessage }) => {
  return (
    <Stack spacing={2}>
      <AutomationProviderSelection />

      {alertMessage && (
        <Alert
          variant="outlined"
          severity="warning"
          sx={{ display: "flex", alignItems: "center" }}
        >
          {alertMessage}
        </Alert>
      )}

      <AutomationAccountsSelection />

      <AutomationRegionsSelection />
    </Stack>
  );
};
